// Copy-paste from rc-calendar@9.7.8 MonthCalendar.jsx
// changes are marked with comments
/* eslint-disable */
import React from "react"
import createReactClass from "create-react-class"
import PropTypes from "prop-types"
import KeyCode from "rc-util/lib/KeyCode"
// change_start
import CalendarHeader from "./CalendarHeader"
import CalendarFooter from "rc-calendar/es/calendar/CalendarFooter"
import CalendarMixin from "rc-calendar/es/mixin/CalendarMixin"
import CommonMixin from "rc-calendar/es/mixin/CommonMixin"
// change_end

const MonthCalendar = createReactClass({
  propTypes: {
    monthCellRender: PropTypes.func,
    dateCellRender: PropTypes.func,
  },
  mixins: [CommonMixin, CalendarMixin],

  getInitialState() {
    return { mode: "month" }
  },

  onKeyDown(event) {
    const keyCode = event.keyCode
    const ctrlKey = event.ctrlKey || event.metaKey
    const stateValue = this.state.value
    const { disabledDate } = this.props
    let value = stateValue
    switch (keyCode) {
      case KeyCode.DOWN:
        value = stateValue.clone()
        value.add(3, "months")
        break
      case KeyCode.UP:
        value = stateValue.clone()
        value.add(-3, "months")
        break
      case KeyCode.LEFT:
        value = stateValue.clone()
        if (ctrlKey) {
          value.add(-1, "years")
        } else {
          value.add(-1, "months")
        }
        break
      case KeyCode.RIGHT:
        value = stateValue.clone()
        if (ctrlKey) {
          value.add(1, "years")
        } else {
          value.add(1, "months")
        }
        break
      case KeyCode.ENTER:
        if (!disabledDate || !disabledDate(stateValue)) {
          this.onSelect(stateValue)
        }
        event.preventDefault()
        return 1
      default:
        return undefined
    }
    if (value !== stateValue) {
      this.setValue(value)
      event.preventDefault()
      return 1
    }
  },

  handlePanelChange(_, mode) {
    if (mode !== "date") {
      this.setState({ mode })
    }
  },

  render() {
    const { props, state } = this
    const { mode, value } = state
    const children = (
      <div className={`${props.prefixCls}-month-calendar-content`}>
        <div className={`${props.prefixCls}-month-header-wrap`}>
          <CalendarHeader
            prefixCls={props.prefixCls}
            mode={mode}
            value={value}
            locale={props.locale}
            disabledMonth={props.disabledMonth}
            monthCellRender={props.monthCellRender}
            monthCellContentRender={props.monthCellContentRender}
            onMonthSelect={this.onSelect}
            onValueChange={this.setValue}
            // change_start
            onPanelChange={this.handlePanelChange}
            yearCellRender={props.yearCellRender}
            disabledYear={props.disabledYear}
            // change_end
          />
        </div>
        <CalendarFooter
          prefixCls={props.prefixCls}
          renderFooter={props.renderFooter}
        />
      </div>
    )
    return this.renderRoot({
      className: `${props.prefixCls}-month-calendar`,
      children,
    })
  },
})

export default MonthCalendar
